import TableCellDescription from "ds/components/Table/Row/CellDescription";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { WorkerPoolsTableRow } from "../types";

const WorkerPoolsTableDescriptionCell = ({
  item: row,
  ...cellProps
}: TableSimpleCellProps<WorkerPoolsTableRow>) => {
  const description = row.kind === "private" ? row.workerPool.description : undefined;

  return (
    <TableSimpleCell {...cellProps}>
      <TableCellDescription description={description} />
    </TableSimpleCell>
  );
};

export default WorkerPoolsTableDescriptionCell;
